import { defineComponent as _defineComponent } from 'vue'
import { UserRoles } from "@/enums/UserRoles";
  
  import LottrackrPoweredIcon from "./ui/LottrackrPoweredIcon.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'MapSideLegend',
  props: {
    isEstateMap: Boolean,
    role: { type: String, default: () => UserRoles.LANDOWNER },
  },
  emits: ["openDocuments"],
  setup(__props, { expose: __expose }) {
  __expose();

  

  const props = __props;

const __returned__ = { props, get UserRoles() { return UserRoles }, LottrackrPoweredIcon }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})